const shippingCosts = {
    title: 'Costi di Spedizione',
    subtitle: 'Scopri le nostre opzioni di spedizione e i tempi di consegna per la tua località',
    selectCountry: 'Seleziona il tuo paese',
    availableOptions: 'Opzioni di spedizione disponibili',
    options: 'opzioni',
    noOptions: 'Nessuna opzione di spedizione disponibile per questo paese',
    contactUs: 'Contattaci per le opzioni di spedizione',
    default: 'Predefinito',
    free: 'Gratuito',
    minOrderAmount: 'Importo minimo ordine',
    aboveMinAmount: 'Sopra l\'importo minimo',
    importantInfo: 'Informazioni importanti',
    info1: 'I costi di spedizione sono calcolati in base al paese selezionato',
    info2: 'La spedizione gratuita è disponibile per ordini superiori all\'importo minimo',
    info3: 'I tempi di consegna possono variare in base alla tua località',
    info4: 'Contattaci per accordi di spedizione speciali',
    loading: 'Caricamento...',
    errorLoading: 'Errore nel caricamento dei costi di spedizione',
    noDescription: 'Nessuna descrizione disponibile'
};

export default shippingCosts;
